import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { TranslationService } from '../../../core/i18n/translation.service';

@Component({
  selector: 'app-checklist-item-definition-number',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './checklist-item-definition-number.component.html',
  styleUrl: './checklist-item-definition.shared.css',
})
export class ChecklistItemDefinitionNumberComponent {
  readonly form = input.required<FormGroup>();
  readonly i18n = input.required<TranslationService>();
}
